//import { ref } from 'vue';
import axios from "axios";

const apiKey = 'dsadafrgrsfsdfsd'
const constanteApi = axios.create({
    baseURL: '/constante',
    //params: {
        //api_key: apiKey
    //}
});

export default constanteApi

/* LRR let url = '/constante/global';
export const constantes = ref({})
export const getConstantes = () => {
    
    axios.get(url).then(function (response) {
        //let constantes = {}
        var respuesta = response.data;
        constantes.value = respuesta.constantes;
        //console.log(constantes);
        //return constantes.value
      
    }).catch(function (error) {
        console.log(error);
  });
}
getConstantes()
//console.log(constantes.value)*/